import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  slot: "content",
  class: "ion-padding"
}
const _hoisted_2 = { slot: "content" }
const _hoisted_3 = { slot: "content" }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_teacher_response_questions = _resolveComponent("teacher-response-questions")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.user.schoolId)
      ? (_openBlock(), _createBlock(_component_ion_card, {
          key: 0,
          class: "outer-card ion-no-margin"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_accordion_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion, {
                  style: {"--min-height":"24px"},
                  value: "mou"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        (!$setup.userSchool.userConsentRecords)
                          ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
                          : ($setup.isMOUAccepted)
                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 1,
                                slot: "start",
                                icon: $setup.checkmarkCircle,
                                color: "success"
                              }, null, 8, ["icon"]))
                            : (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 2,
                                slot: "start",
                                icon: $setup.alertCircle,
                                color: "danger"
                              }, null, 8, ["icon"])),
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _cache[9] || (_cache[9] = _createTextVNode(" 1. MOU between ")),
                            _cache[10] || (_cache[10] = _createElementVNode("b", null, "FDMT Consulting", -1)),
                            _cache[11] || (_cache[11] = _createTextVNode(" and ")),
                            _createElementVNode("b", null, _toDisplayString($setup.user.schoolId?.toUpperCase()), 1),
                            _cache[12] || (_cache[12] = _createTextVNode(" (the School) "))
                          ]),
                          _: 1,
                          __: [9,10,11,12]
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "8" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                class: "no-text-transform",
                                expand: "block",
                                href: "https://fdmt.hk/mou",
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.documentOutline
                                  }, null, 8, ["icon"]),
                                  _cache[13] || (_cache[13] = _createTextVNode(" Open MOU Document "))
                                ]),
                                _: 1,
                                __: [13]
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                class: "no-text-transform",
                                fill: "clear",
                                expand: "block",
                                href: "https://docs.google.com/feeds/download/documents/export/Export?id=1Xmk67g9b2cpiaCwkwmVIGbayzvq9xug-dKdHVN5-jbg&exportFormat=pdf",
                                target: "_blank"
                              }, {
                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                  _createTextVNode(" Download ")
                                ])),
                                _: 1,
                                __: [14]
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("p", null, [
                        ($setup.isPrincipal || $setup.user.isAdmin)
                          ? (_openBlock(), _createBlock(_component_ion_checkbox, {
                              key: 0,
                              "label-placement": "end",
                              onIonChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleMouAcceptance($event))),
                              checked: $setup.isMOUAccepted,
                              disabled: $setup.isMOUAccepted
                            }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createTextVNode("I have read and approve the MOU")
                              ])),
                              _: 1,
                              __: [15]
                            }, 8, ["checked", "disabled"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            ($setup.isPrincipal || $setup.user.isAdmin)
              ? (_openBlock(), _createBlock(_component_ion_item, {
                  key: 0,
                  lines: "full",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openSchoolTeacherModal())),
                  button: "",
                  detail: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      icon: $setup.informationCircleOutline
                    }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode(" 2. Registered teachers verified ")
                      ])),
                      _: 1,
                      __: [16]
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_item, {
              lines: "full",
              target: "_blank",
              button: "",
              detail: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openBookingModal('bi0fd219e9')))
            }, {
              default: _withCtx(() => [
                ($setup.isSubmittedTeacherResponse('achievejupas-b1') && $setup.isSubmittedTeacherResponse('achievejupas-b1t'))
                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 0,
                      slot: "start",
                      icon: $setup.checkmarkCircle,
                      color: "success"
                    }, null, 8, ["icon"]))
                  : (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 1,
                      slot: "start",
                      icon: $setup.alertCircle,
                      color: "danger"
                    }, null, 8, ["icon"])),
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("3. Sep/Oct briefing (same-day students & teachers)")
                  ])),
                  _: 1,
                  __: [17]
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, {
              lines: "full",
              target: "_blank",
              button: "",
              detail: "",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openBookingModal('bi6ef13f36')))
            }, {
              default: _withCtx(() => [
                ($setup.isSubmittedTeacherResponse('achievejupas-b2') && $setup.isSubmittedTeacherResponse('achievejupas-b2t'))
                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 0,
                      slot: "start",
                      icon: $setup.checkmarkCircle,
                      color: "success"
                    }, null, 8, ["icon"]))
                  : (_openBlock(), _createBlock(_component_ion_icon, {
                      key: 1,
                      slot: "start",
                      icon: $setup.alertCircle,
                      color: "danger"
                    }, null, 8, ["icon"])),
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("4. Feb/Mar briefing (same-day students & teachers)")
                  ])),
                  _: 1,
                  __: [18]
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, {
              lines: "full",
              target: "_blank",
              button: "",
              detail: "",
              href: `https://fdmt.hk/r/${$setup.user.schoolId}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "start",
                  icon: $setup.informationCircleOutline
                }, null, 8, ["icon"]),
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("5. Report "),
                    _createElementVNode("small", null, "(your Google account needed for secured sharing)", -1)
                  ])),
                  _: 1,
                  __: [19]
                })
              ]),
              _: 1
            }, 8, ["href"]),
            _createVNode(_component_ion_accordion_group, { value: "onboard" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_accordion, {
                  style: {"--min-height":"24px"},
                  value: "onboard"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      slot: "header"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createTextVNode("Onboard")
                          ])),
                          _: 1,
                          __: [20]
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_ion_segment, {
                        mode: "ios",
                        scrollable: true,
                        modelValue: $setup.targetTeacherRole,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.targetTeacherRole) = $event)),
                        onIonChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.checkOpenTeacherModal()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.checkedSchoolTeacherRoles().roleObjs, (roleObj, idx) => {
                            return (_openBlock(), _createBlock(_component_ion_segment_button, {
                              key: idx,
                              layout: "icon-start"
                            }, {
                              default: _withCtx(() => [
                                (roleObj.relatedTeacher)
                                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                                      key: 0,
                                      size: "small",
                                      color: "success",
                                      icon: $setup.checkmarkCircle
                                    }, null, 8, ["icon"]))
                                  : (_openBlock(), _createBlock(_component_ion_icon, {
                                      key: 1,
                                      size: "small",
                                      color: "danger",
                                      icon: $setup.alertCircle
                                    }, null, 8, ["icon"])),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(roleObj.role), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            ($setup.recentResponses().length > 0)
              ? (_openBlock(), _createBlock(_component_ion_accordion_group, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_accordion, { style: {"--min-height":"24px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          lines: "full",
                          slot: "header"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                _createTextVNode("My recent responses/actions")
                              ])),
                              _: 1,
                              __: [21]
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_3, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recentResponses().slice(0, 10), (resp, idx) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              key: idx,
                              lines: "full",
                              detail: "",
                              button: "",
                              onClick: ($event: any) => ($setup.openServiceModal(resp.serviceId))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", null, [
                                      (resp.eventName)
                                        ? (_openBlock(), _createElementBlock("b", _hoisted_4, _toDisplayString(resp.eventName) + ":", 1))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" " + _toDisplayString(resp.response) + " ", 1),
                                      _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                                      _createElementVNode("small", null, _toDisplayString($setup.formatDate(resp.updatedAt)), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_item, {
              lines: "none",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openTeacherRolesModal())),
              button: "",
              detail: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode("Your profile")
                  ])),
                  _: 1,
                  __: [23]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_modal, {
      "is-open": $setup.bookTimeData.isModalOpened,
      "backdrop-dismiss": false,
      "show-backdrop": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_buttons, { slot: "start" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      slot: "icon-only",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.bookTimeData.isModalOpened = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: $setup.arrowBack }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_title, {
                  class: "ion-text-left",
                  style: {"padding-left":"0"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, [
                          _createElementVNode("b", null, "Book a time for " + _toDisplayString($setup.bookTimeData.title), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_content, { class: "ion-padding" }, {
          default: _withCtx(() => [
            _createVNode(_component_teacher_response_questions, {
              serviceId: $setup.bookTimeData.serviceId,
              group: "service",
              showSubmitBtn: true,
              onResponseSubmitted: _cache[8] || (_cache[8] = ($event: any) => ($setup.bookTimeData.isModalOpened = false))
            }, null, 8, ["serviceId"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}